module.exports = __webpack_public_path__ + "img/12_78.5d0d1489.png";